<template>
  <div>
    <BCard class="border">
      <div>
        <b-form-file
          multiple
          @change="onFileChange"
          v-model="images"
          id="productImagesFile"
          class="d-none"
        >
        </b-form-file>
        <label class="btn btn-primary" for="productImagesFile"
          >افزودن تصاویر</label
        >
      </div>
      <div>
        <div class="product-files-grid mt-4">
          <div
            class="border rounded d-flex align-items-center justify-content-center product-file-item position-relative"
            v-for="(file, index) in realValue"
            :key="index"
          >
            <img class="w-100 h-100" :src="imgResolver(file)" alt="" />

            <!-- <i
              @click="deleteFilesItem(file, index)"
              class="feather feather-trash text-white btn btn-danger px-1 py-0 product-file-delete position-absolute"
            ></i> -->
          </div>
        </div>
      </div>
    </BCard>
  </div>
</template>
<script>
import ImagesImpl from "@@/core/components/product/Images/ImagesImpl.js";
export default {
  extends: ImagesImpl,
};
</script>
<style src="@@/core/components/product/Images/ImagesStyle.css"></style>
